// extracted by mini-css-extract-plugin
export default {"image":"n9fc41xu"};